import { fontWeight } from "@mui/system";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";

import { Table } from "../MoveOutTerminationTabs/MoveOut.styled";

import calendar from "../../assets/calendar.svg";
import { LabelDiv } from "../../components/PaymentPlanTabs/Tabs.styled";

import NocsRequests from '../../stores/NocsRequestsStore';
import { observer } from "mobx-react";
import General from '../../stores/GeneralStore'
import { CircularProgress } from "@mui/material";
import OurServicesContent from "../ServicesTab/OurServices/OurServicesContent";
import generalStore from "../../stores/GeneralStore";


interface Obj {
  [key: string]: string | {} | [];
}

interface Props extends BaseProps {
  onClose: () => void,
  title:any,
}


const TrackRequestsTes = ({ onClose,title }: Props) => {

    const [bannerTitle, setBannerTitle] = useState("");
    // const [isLargeScreen, setIsLargeScreen] = useState(false);
    
    //   useEffect(() => {
    //     function handleResize() {
    //       setIsLargeScreen(window.innerWidth > 991);
    //       generalStore?.setLargeScreen(window.innerWidth > 991);
    //     }
    //     window.addEventListener("resize", handleResize);
    //     handleResize();
    
    //     return () => window.removeEventListener("resize", handleResize);
    //   }, []);
  
  return (
    <div style={{ margin: window.innerWidth < 600 ? "1rem 0.5rem" : "3rem",display:'flex',flexDirection:'column',alignItems:'center',direction:General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"? "rtl": "ltr",width: "100%",
      boxSizing: "border-box"}}>
     

      <div
        style={{
          backgroundColor: "#101e8e",
          padding: window.innerWidth < 600 ? '1em' : '1.5em',
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width:window.innerWidth < 600 ? "100%" : "60%",
          boxSizing: "border-box",
          borderRadius: window.innerWidth < 600 ? 8 : 12,
        }}
      >
        <h1
          id="modal-title"
          style={{
            color: "white",
            margin: 0,
            fontSize: `${2 * General.accessibility.fontSize}rem`,
          }}
        >
          {bannerTitle.charAt(0).toUpperCase() + bannerTitle.slice(1)}
        </h1>
        <span
          style={{
            color: "white",
            fontSize: `${2 * General.accessibility.fontSize}rem`,
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          x
        </span>
      </div>

      <div
        style={{
          overflowY: "auto",
          backgroundColor: "#fff",
          // padding: "30px",
          // paddingRight:'30px',
          color: "#101E8E",
          height: window.innerWidth < 600 ? "70vh" : "80vh",
          background:'rgba(229, 239, 242, 0.7)' ,
          width:window.innerWidth < 600 ? "100%" : "60%",
          boxSizing: "border-box",
          borderRadius: window.innerWidth < 600 ? 8 : 12,
        }}
      >
      <OurServicesContent pageLink={title} setBannerTitle={setBannerTitle} />

      </div>
    </div>
  );
};

export default observer(TrackRequestsTes);